/*テキスト検索*/
import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from './Messages';
import Paragraph from './Paragraph';
import { Button } from 'react-bootstrap';

interface Props {
  id: string;
  label: string;
  need?: boolean;
  value: string;
  handleChange?: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  disabled: boolean;
  message?: string;
  help_msg?: string;
  readonly: boolean;
  clickCallback?: () => void;
}

const TextWithSearch: React.FC<Props> = ({
  id,
  label,
  need,
  value,
  handleChange,
  disabled,
  message,
  help_msg,
  readonly,
  clickCallback,
}) => {
  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      content={
        disabled ? (
          <Paragraph label={value} />
        ) : (
          <>
            <Row>
              <Col xs={7} className="pr-0">
                <Form.Control
                  type="text"
                  id={id}
                  onChange={handleChange}
                  value={value}
                  disabled={disabled}
                  maxLength={4}
                  readOnly={readonly}
                />
              </Col>
              <Col xs={4} className="pr-0">
                <Button disabled={disabled} onClick={clickCallback} variant="outline-secondary">
                  検索
                </Button>
              </Col>
            </Row>
            <Messages help_msg={help_msg} valid_msg={message} />
          </>
        )
      }
    />
  );
};

export default TextWithSearch;
